import { TileRectangle } from "../runescape/coordinates";
import { Rectangle, Vector2 } from "../math";
import { TileArea } from "../runescape/coordinates/TileArea";
export default class BoundsBuilder {
    constructor() {
        this.bounds = null;
        this.level = null;
        this.distance_limit = null;
        this.fixed_center = false;
        this.level_fixed = false;
    }
    setDistanceLimit(limit) {
        if (limit != null) {
            this.distance_limit = {
                limit: limit,
                center: Rectangle.center(this.bounds)
            };
        }
        else {
            this.distance_limit = null;
        }
        return this;
    }
    fixCenter(v = true) {
        this.fixed_center = v;
        return this;
    }
    fixLevel(v = true) {
        this.level_fixed = v;
        return this;
    }
    addTile(...tiles) {
        for (let tile of tiles) {
            if (!tile)
                continue;
            if (this.distance_limit != null && tiles.some(tile => Vector2.lengthSquared(Vector2.sub(this.distance_limit.center, tile)) > this.distance_limit.limit * this.distance_limit.limit))
                continue;
            if (!this.bounds) {
                this.bounds = { topleft: tile, botright: tile };
            }
            else {
                if (this.fixed_center)
                    this.bounds = Rectangle.extendTo(this.bounds, Vector2.mirrorThroughPoint(tile, Rectangle.center(this.bounds)));
                this.bounds = Rectangle.extendTo(this.bounds, tile);
            }
            if ("level" in tile && !this.level_fixed) {
                if (this.level == null)
                    this.level = tile.level;
                else
                    this.level = Math.min(this.level, tile.level);
            }
        }
    }
    addRectangle(rect) {
        if (!rect)
            return;
        if ("level" in rect) {
            this.addTile(TileRectangle.tl(rect));
            this.addTile(TileRectangle.br(rect));
        }
        else {
            this.addTile(rect.topleft);
            this.addTile(rect.botright);
        }
    }
    addArea(area) {
        if (!area)
            return;
        this.addRectangle(TileArea.toRect(area));
    }
    get() {
        if (!this.bounds)
            return null;
        return {
            topleft: this.bounds.topleft,
            botright: this.bounds.botright,
            level: this.level || 0
        };
    }
}
